if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      let variants = JSON.parse(document.querySelector('[data-product-variants]').textContent);
      let id = this.form.querySelector('[name=id]');
      id.disabled = false;
      if(typeof id.dataset.variantId !== "undefined") {
        updateVariantsByLocations(variants).then(() => {
          this.updateKlaviyoBtn(variants[0]);
          let isFound = variants.filter(v => v.found === true);
          let isAvailable = variants.filter(v => v.available === true);
          if(isFound.length === 0) {
            this.toggleAddButton(true, '', true);
            this.setUnavailable(window.variantStrings.unavailable);
            this.hideNotifyButton();
          } else if (isAvailable.length === 0) {
            this.toggleAddButton(true, '', true);
            this.setUnavailable(window.variantStrings.soldOut);
          }
          id.value = id.dataset.variantId;
        });
      }
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.updateReviewsText();
      if (location.hash != '') {
        setTimeout(function() {
          location.href = location.hash;
        }, 2000)
      }
    }

    hideNotifyButton() {
      this.form.classList.add('not-available');
    }
    
    setUnavailable(status) {
      const addButton = this.form.querySelector('[name="add"]');
      const addButtonText = this.form.querySelector('[name="add"] > span');
      if (!addButton) return;
      addButtonText.textContent = status;
    }

    toggleAddButton(disable = true, text, modifyClass = true) {
      const addButton = this.form.querySelector('[name="add"]');
      const addButtonText = this.form.querySelector('[name="add"] > span');

      if (!addButton) return;

      if (disable) {
        addButton.setAttribute('disabled', 'disabled');
        if (text) addButtonText.textContent = text;
      } else {
        addButton.removeAttribute('disabled');
        addButtonText.textContent = window.variantStrings.addToCart;
      }

      if (!modifyClass) return;
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            let message = response.description;
            if (response.description == "Required parameter missing or invalid: id") {
              message = "Please select a variant before adding to cart";
            }
            this.handleErrorMessage(message);
            return;
          }
          const event = new CustomEvent("ehAddProductToCart", {detail: response});
          window.dispatchEvent(event);
          this.cartNotification.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    updateReviewsText() {
      function updateElements() {
        let count = 0;
        const timer = setInterval(function() {
          const elements = document.querySelectorAll('.junip-product-summary-review-count');
          if (elements.length > 0) {
            elements.forEach((element => {
              let html = element.innerHTML.trim().replace('(', '').replace(')', '');
              if (!isNaN(html)) {
                html = parseInt(html);
                element.innerHTML = `Read ${html} ${html > 1 ? 'reviews' : 'review'}`;
              }
            }));
          }
          count += 500;
          if (count > 5000) clearInterval(timer);
        }, 500);
      }
      updateElements();
      window.addEventListener('resize', function(event) {
        updateElements();
      }, true);
      window.addEventListener('orientationchange', function(event) {
        updateElements();
      }, true);
    }

    updateKlaviyoBtn(variant) {
      const event = new CustomEvent("ehUpdateKlaviyoBtn", {detail: {'variant':variant}});
      const productEvent = new CustomEvent(`ehUpdateKlaviyoBtn${variant.product_id}`, {detail: {'variant':variant}});
      window.dispatchEvent(event);
      window.dispatchEvent(productEvent);
    }
  });
}

if (!customElements.get('upsell-grid-actions')) {
  customElements.define('upsell-grid-actions', class UpsellGridActions extends HTMLElement {
    constructor() {
      super();
      this.handle = this.getAttribute('handle');
      this.product = this.getAttribute('product');
      this.section = this.getAttribute('section');
      this.button = this.querySelector('button');
      if(this.button) {
        this.input = this.button.nextSibling;
        this.button.addEventListener('click', this.onSubmitHandler.bind(this));
        this.input.addEventListener('change', this.onChangeHandler.bind(this));
        this.mainImage = this.input.dataset.mainImage;
      }
      this.parentEl = this.closest('.item');
      this.imageEl = this.parentEl.querySelector('.col-image img');
      this.cartNotification = document.querySelector('cart-notification');
      this.fetchHeaders = new Headers();
      this.fetchHeaders.append('pragma', 'no-cache');
      this.fetchHeaders.append('cache-control', 'no-store');
      this.fetchHeaders.append('Content-Type', 'application/json');
      this.priceContainer = this.querySelector('.upsell-price');
    }

    onChangeHandler(evt) {
      const selected = evt.target.options[evt.target.selectedIndex];
      const productSectionUrl = `/products/${this.handle}?variant=${evt.target.value}&section_id=${this.section}`;
      const priceId = `price-${this.section}`;

      let atcButton = this.querySelector('[type="button"]');
      if (atcButton.classList.contains('loading')) return;

      atcButton.setAttribute('aria-disabled', true);
      atcButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      fetch(productSectionUrl)
          .then(response => response.text())
          .then(text => {
            const sectionInnerHTML = new DOMParser()
                .parseFromString(text, 'text/html')
                .getElementById(priceId);
            if(sectionInnerHTML) {
              this.priceContainer.innerHTML = sectionInnerHTML.innerHTML;
              var moneyElements = document.querySelectorAll('span.money');
              if (moneyElements) {
                Array.prototype.forEach.call(moneyElements, function (moneyEle) {
                  Shopify.theme.currencyConverter.update(moneyEle);
                });
              }
            }
            if(selected && selected.dataset.image) {
              this.imageEl.src = selected.dataset.image;
            } else {
              this.imageEl.src = this.mainImage;
            }
          })
          .catch(e => console.error(e))
          .finally(e => {
            atcButton.classList.remove('loading');
            atcButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.button.classList.contains('loading')) return;

      this.handleErrorMessage();

      this.button.setAttribute('aria-disabled', true);
      this.button.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      var data = {
        items: [],
        sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      }
      var item = {id: this.input.value, quantity: 1};
      data.items.push(item);
      var body = JSON.stringify(data);

      fetch('/cart/add.js', {method: 'POST', headers: this.fetchHeaders, body})
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              return;
            }
            const event = new CustomEvent("ehAddProductToCart", {detail: response});
            window.dispatchEvent(event);
            this.cartNotification.renderContents(response);
          })
          .catch((e) => console.error(e))
          .finally(() => {
            this.button.classList.remove('loading');
            this.button.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

// Recharge price update
(function() {
  let lastVal = '';

  function updatePrice() {
    const form = document.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;

    const val = form.querySelector('input[name="selling_plan"]')?.value || '';
    if (val === lastVal) return;
    lastVal = val;

    const prices = window.SubscriptionWidgetConfig?.formattedPrices;
    const productPrices = prices && prices[Object.keys(prices)[0]];
    if (!productPrices) return;

    const regPriceEl = document.querySelector('.product-form__submit [data-price-wrapper] .money');
    const fsbShippingMessage = document.querySelector('#fsb_placeholder, #b2b_shipping_message');
    const subscriptionShippingMessage = document.querySelector('#subscription-shipping');

    if (val) {
      if (regPriceEl) regPriceEl.textContent = productPrices.discounted;
      fsbShippingMessage?.classList.add('hidden');
      subscriptionShippingMessage?.classList.remove('hidden');
    } else {
      if (regPriceEl) regPriceEl.textContent = productPrices.unit;
      fsbShippingMessage?.classList.remove('hidden');
      subscriptionShippingMessage?.classList.add('hidden');
    }
  }

  setInterval(updatePrice, 200);
})();